module.exports = __webpack_public_path__ + "static/media/BOTON WEB_Arte.27bf1352.png";